import PropTypes from "prop-types";

import { Chip, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { statusColors, statusLabels } from "@/features/sales-invoices";
import { formatDate } from "@/features/shared";
import { UpstreamTransactionLink } from "@/features/ui";

export const GeneralInformationSection = ({ salesDownPayment }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Status
          </Typography>
          {salesDownPayment.status && (
            <Chip
              label={statusLabels[salesDownPayment.status]}
              color={statusColors[salesDownPayment.status]}
              size="small"
            />
          )}
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh
          </Typography>
          <Typography variant="body1">
            {salesDownPayment.creator?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(salesDownPayment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pelanggan
          </Typography>
          <Typography variant="body1">
            {salesDownPayment.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Penjual
          </Typography>
          <Typography variant="body1">
            {salesDownPayment.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Syarat Pembayaran
          </Typography>
          <Typography variant="body1">
            {salesDownPayment.paymentTerm?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pesanan Penjualan
          </Typography>
          <UpstreamTransactionLink
            referenceNumber={salesDownPayment.salesOrder?.referenceNumber}
            shortReference={false}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">{salesDownPayment.note ?? "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  salesDownPayment: PropTypes.object.isRequired,
};
